import Pusher from "pusher-js";
import axios from "axios";

// Instancia única de Pusher para toda la app: la usan las notificaciones del
// header (siempre conectadas mientras hay sesión), el chat y el dashboard de
// intakes. Por eso las páginas NO tienen que llamar a disconnectPusher() al
// salir: cortarían también las notificaciones. Que cada una se desuscriba de
// SU canal con unsubscribeFromChannel().
let pusher = null;

/**
 * Firma de los canales privados (private-…). Pusher no deja suscribirse a un
 * canal privado sin una firma que solo da nuestra API (POST broadcasting/auth)
 * y solo si el usuario tiene permiso para ese canal. Se lee el token en cada
 * pedido para que sirva aunque la sesión haya cambiado.
 */
function autorizarCanal({ socketId, channelName }, callback) {
    const token = localStorage.getItem("token");
    if (!token) {
        callback(new Error("Sin sesión"), null);
        return;
    }
    axios
        .post(
            `${process.env.VUE_APP_API_URL}broadcasting/auth`,
            { socket_id: socketId, channel_name: channelName },
            { headers: { Authorization: token } }
        )
        .then((r) => callback(null, r.data))
        .catch((e) => callback(e, null));
}

/**
 * Inicializa Pusher con configuración.
 */
export function initializePusher() {
    if (pusher) return pusher;
    try {
        if (process.env.NODE_ENV !== 'production') {
            // Habilitar logs en consola para debug en desarrollo
            try { Pusher.logToConsole = true } catch (e) { /* ignore */ }
        }
    } catch (e) { /* ignore */ }

    pusher = new Pusher(process.env.VUE_APP_PUSHER_KEY, {
        cluster: process.env.VUE_APP_PUSHER_CLUSTER,
        forceTLS: true,
        channelAuthorization: { customHandler: autorizarCanal },
    });
    try {
        pusher.connection.bind('error', (err) => console.warn('Pusher connection error', err))
    } catch (e) { /* ignore */ }
    return pusher;
}

/** La instancia (la crea si hace falta). */
export function getPusher() {
    return initializePusher();
}

/**
 * Suscribirse a un canal.
 * @param {String} channelName - Nombre del canal.
 * @param {String} eventName - Nombre del evento.
 * @param {Function} callback - Función de callback para manejar el evento.
 * @returns el canal de Pusher.
 */
export function subscribeToChannel(channelName, eventName, callback) {
    if (!pusher) initializePusher();
    const channel = pusher.channel(channelName) || pusher.subscribe(channelName);
    channel.bind(eventName, callback);
    return channel;
}

/**
 * Cancelar la suscripción a un canal.
 * @param {String} channelName - Nombre del canal.
 */
export function unsubscribeFromChannel(channelName) {
    if (pusher) pusher.unsubscribe(channelName);
}

/**
 * Detener Pusher. Solo al cerrar sesión (lo hace el módulo de notificaciones):
 * desde una página cortaría las notificaciones del header.
 */
export function disconnectPusher() {
    if (pusher) {
        pusher.disconnect();
        pusher = null;
    }
}
